const cardData = [
  {
    skillType: "gameDesign",
    id: 1,
    title: "小遊戲設計",
    url: "https://drive.google.com/thumbnail?id=1gnnO1juWKUm_xuU94PI7naVzH_8GkQwT&sz=w1000",
    description:
      "全程主導小遊戲「養魚小幫手」的創作，從概念構想到實現，根據客戶需求精心設計遊戲流程與界面。確保每一個視覺細節都與品牌風格和目標用戶匹配，並為遊戲注入高度的趣味性與沉浸感，展現卓越的創意與執行能力。",
  },
  {
    skillType: "unityLearningPlatform",
    id: 2,
    title: "Unity 教學平台開發",
    url: "https://drive.google.com/thumbnail?id=1gnnO1juWKUm_xuU94PI7naVzH_8GkQwT&sz=w1000",
    description:
      "以 Unity 開發專為小學生打造的數位學習平台，創造充滿吸引力的互動體驗。整合 3D 模型、動畫與場景管理技術，構建沉浸式學習環境，為教育科技開啟全新可能性。",
  },
  {
    skillType: "uiUxDesign",
    id: 3,
    title: "UI and UX 設計",
    url: "https://static.vecteezy.com/system/resources/previews/000/602/787/original/creative-letter-z-logo-concept-design-templates-vector.jpg",
    description:
      "專注於 UI 和 UX 設計，致力於提供簡潔、直觀且功能完備的用戶體驗。憑藉對用戶需求的深刻理解，將創意轉化為高效的設計解決方案，充分滿足品牌的形象定位與市場需求。",
  },
  {
    skillType: "arDevelopment",
    id: 4,
    title: "AR 應用開發",
    url: "https://static.vecteezy.com/system/resources/previews/000/602/787/original/creative-letter-z-logo-concept-design-templates-vector.jpg",
    description:
      "專業運用 AR Foundation 技術開發增強現實應用，結合創新思維與技術實力，構建極具沉浸感的互動式場景，為教育、展示和品牌推廣提供突破性的體驗解決方案。",
  },
  {
    skillType: "videoEditing",
    id: 5,
    title: "專業影片剪輯",
    url: "https://static.vecteezy.com/system/resources/previews/000/602/787/original/creative-letter-z-logo-concept-design-templates-vector.jpg",
    description:
      "提供專業的影片剪輯服務，涵蓋從腳本策劃到視覺特效的全流程。精通 Adobe Premiere 和 After Effects，創造出既能吸引目光又富有敘事性的視覺作品，為客戶實現品牌價值的最大化。",
  },
  {
    skillType: "shortVideoProduction",
    id: 6,
    title: "短影片製作",
    url: "https://drive.google.com/thumbnail?id=1-YX7sPFvJ4Kl-xQte7SULEH_FVTf3Vho&sz=w1000",
    description:
      "專注於短影片製作，善於快速構思與精確執行，從影片拍攝到後期優化，為社交媒體推廣創造高質量、吸引目標受眾的內容，助力客戶拓展品牌影響力。",
  },
  {
    skillType: "webDesign",
    id: 7,
    title: "網站設計",
    url: "https://drive.google.com/thumbnail?id=1-_Vld-WErsXY27_o9BvJunwL2av3RnCl&sz=w1000",
    description:
      "設計專業且極具吸引力的網站，採用簡約大方的介面設計，透過黑白灰的色彩策略突出關鍵信息，為用戶創建直觀且高效的瀏覽體驗，同時增強品牌的專業形象。",
  },
  {
    skillType: "posterDesign",
    id: 8,
    title: "海報及印刷品設計",
    url: "https://drive.google.com/thumbnail?id=1--CurQZ3U1F64FnN-vkqWuoOtfN75V3x&sz=w1000",
    description:
      "專精於海報與印刷品設計，從品牌識別到視覺敘事，為客戶提供高質量的設計解決方案。細緻考量配色與版面布局，確保每件作品既符合品牌形象，又能打動目標受眾。",
  },
  {
    skillType: "modeling",
    id: 9,
    title: "3D 建模",
    url: "https://drive.google.com/thumbnail?id=1AW2z8CYT3tLvclozs3TMS5dO1PYEB9WK&sz=w1000",
    description:
      "以 Blender 製作香港柴灣角天主教小學的精準 1:1 模型，應用於學校的元宇宙虛擬學習平台。模型忠實還原學校建築，提升學生在虛擬世界中的學習體驗，展示出對教育科技應用的深刻理解與實踐能力。",
  },
  {
    skillType: "virtualLearningPlatform",
    id: 10,
    title: "香港小學虛擬學習平台",
    url: "https://drive.google.com/thumbnail?id=1Jk0qXl_iAPoWOh-80AJgmE4hxzcRbzj-&sz=w1000",
    description:
      "全程主導虛擬學習平台的開發，包括 3D 建模、Unity 中的 C# 程式開發與 Shader 技術，並結合 Firebase 作為後端資料管理。此平台為小學生提供沉浸式互動學習環境，展現出對技術整合與創新教育的深厚專業素養。",
  },
];
export default cardData;
